import qs from 'qs';
import axios from 'axios';
import Jsona from 'jsona';

const url = process.env.VUE_APP_API_BASE_URL;
const jsona = new Jsona();

function list(params) {
    const options = {
        params: params,
        paramsSerializer: function(params) {
            return qs.stringify(params, { encode: false });
        }
    };

    return axios.get(`${url}/licences?include=licenceCashRegisters`, options)
        .then(response => {
            return {
                list: jsona.deserialize(response.data),
                meta: response.data.meta
            };
        });
}

function get(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/licences/${id}`, options)
        .then(response => {
            let licence = jsona.deserialize(response.data);
            delete licence.links;
            return licence;
        });
}

function getAvailableLicencesCount() {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.get(`${url}/available-licences`, options)
        .then(response => {
            let availableLicences = jsona.deserialize(response.data);
            delete availableLicences.links;
            return availableLicences;
        });
}

function add(licence) {
    const payload = jsona.serialize({
        stuff: licence,
        includeNames: null
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.post(`${url}/licences`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function update(licence) {
    const payload = jsona.serialize({
        stuff: licence,
        includeNames: []
    });

    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.patch(`${url}/licences/${licence.id}`, payload, options)
        .then(response => {
            return jsona.deserialize(response.data);
        });
}

function destroy(id) {
    const options = {
        headers: {
            'Accept': 'application/vnd.api+json',
            'Content-Type': 'application/vnd.api+json',
        }
    };

    return axios.delete(`${url}/licences/${id}`, options);
}

export default {
    list,
    get,
    getAvailableLicencesCount,
    add,
    update,
    destroy
};